import ErrorSignal from 'assets/icons/signal/error.svg'
import SuccessSignal from 'assets/icons/signal/success.svg'

const FEEDBACK_STATUS = {
  error: {
    title: 'Não foi possível autorizar o acesso.',
    description: 'Tente novamente mais tarde.',
    button: 'Entendi',
    icon: ErrorSignal,
  },
  successRedirect: {
    title: 'Acesso autorizado com sucesso',
    description: 'Clique abaixo para retornar ao seu navegador.',
    button: 'Concluir',
    icon: SuccessSignal,
  },
  successNoRedirect: {
    title: 'Acesso autorizado com sucesso',
    description: 'Você já pode voltar para o seu navegador.',
    button: 'Entendi',
    icon: SuccessSignal,
  },
  noConsents: {
    title: 'Você não possui conexões',
    description:
      'Quando você se conectar pela primeira vez, poderá ver e cancelar suas conexões nesta página',
  },
  blockedKidsAccount: {
    title: 'Não foi possível autorizar o acesso.',
    description: 'Login disponível apenas para maiores de 18 anos.',
    button: 'Entendi',
    icon: ErrorSignal,
  },
  accountCreatedNoRedirect: {
    title: 'Seu cadastro :clientName foi criado',
    description: 'Você já pode voltar para o seu navegador.',
    button: 'Entendi',
    icon: SuccessSignal,
  },
  accountCreatedRedirect: {
    title: 'Acesso autorizado com sucesso',
    description: 'Clique abaixo para retornar ao seu navegador.',
    button: 'Concluir',
    icon: SuccessSignal,
  },
}

export { FEEDBACK_STATUS }
